<template>
    <div class="business-current">
        <transition name="fade-transform" mode="out-in">
            <router-view/>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "business-current",
        data() {
            return {}
        },
        created() {

        },
        mounted() {
        },
        methods: {}
    }
</script>

<style scoped lang="scss">
    .business-current {

    }
</style>